
export default {
  props: {
    variant: {
      type: String,
      validator: val =>
        ["positive", "negative", "warning", "info"].includes(val),
      required: true
    },
    message: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    header: {
      type: String,
      default: null
    },
    headerTextSize: {
      type: String,
      validator: val => ["medium"].includes(val),
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      if (this.icon) {
        return { [this.icon]: true }
      }
      return {
        "icon-alert": this.variant === "negative" || this.variant === "warning",
        "icon-selected": this.variant === "positive",
        "icon-info": this.variant === "info"
      }
    },
    feedbackClass() {
      return {
        "feedback-dialog__full-width": this.fullWidth,
        [`feedback-dialog--${this.variant}`]: this.variant
      }
    }
  },
  methods: {
    triggerVote() {
      this.$emit("energyVote", this.voteKey)
    },
    handleClick() {
      this.flipCard = this.flipCard === "click" ? "default" : "click"
    }
  }
}
